export const createRAFUpdater = () => {
    let rafId: number | undefined;

    return {
        update: (callback: () => void) => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(callback);
        },
        cancel: () => {
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = undefined;
            }
        },
    };
};
